module.exports = __webpack_public_path__ + "static/book_01-960x550-2045e956b742dcb4157d09a5ffbeba30.jpg";